query AnalyticsViewsByCountry($filter: AnalyticsViewsFilterInput!, $limit: Int) {
  analyticsViews(filter: $filter) {
    viewsByCountry(limit: $limit) {
      countryCode
      views
      visitors
    }
  }
}
